
<template>
  <div>
      <vx-card title="Account Detail">
      
    <vs-input
      v-validate="'required|alpha_dash|min:3'"
      data-vv-validate-on="blur"
      label="Name"
      name="Name"
      placeholder="Enter Your Name"
      v-model="name"
      class="w-full mb-6" />
    <span class="text-danger text-sm">{{ errors.first('displayName') }}</span>

    <vs-input
      v-validate="{required: true,regex:/\b[\w\.-]+@((?!gmail|googlemail|yahoo|hotmail).)[\w\.-]+\.\w{2,4}\b/}"
      data-vv-validate-on="blur"
      name="email"
      type="email"
      label="Email"
      disabled
      placeholder="Email"
      v-model="email"
      class="w-full mb-6" />
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>


    <div v-if="country" class="w-full mb-6">
      <vue-tel-input mode='national' :valid-characters-only="true" :defaultCountry="countryIso" v-model="phone" :dynamicPlaceholder="false" name="phone" type="number" v-on:country-changed="countryChanged" :disabledFetchingCountry="true" :enabledCountryCode="false"   class="vx-col w-full"	 ></vue-tel-input>
      
    </div>



     
      
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button @click="updateUser" class="mr-3 mb-2">Submit</vs-button>
          
        </div>
      </div>
      </vx-card>
  </div>
</template>


<script>
export default {
  mounted(){
    this.getUserData();
  },
  data(){
    return{
      name:'',
      email:'',
      phone:'',
      countryCode: '',
      country: '',
      countryIso:''
    }
  },
  computed:{
    validateForm () {
      return !this.errors.any() && this.name !== '' && this.phone !== '' && this.country !== '' && this.email !== '' && this.password !== '' && this.confirm_password !== '' && this.isTermsConditionAccepted === true
    },
  },
  methods:{
    getUserData(){
      
      this.$store.dispatch('user/getUserData')
      .then((response) => {  
        this.id = response.data.data.id
        this.name = response.data.data.name
        this.email = response.data.data.email
        this.country = response.data.data.country
        this.countryIso = response.data.data.countryIso
        this.countryCode = response.data.data.countryCode
        this.phone = response.data.data.phone

        })
      .catch(error => {
        this.$vs.notify({
            time:3000,
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
      })
      
    },

    updateUser(){
      const payload = {
        id         : this.id,
        name       : this.name,
        phone      : this.phone,
        country    : this.country,
        countryIso : this.countryIso,
        countryCode: this.countryCode
      }
      this.$store.dispatch('user/updateUser', payload)
      .then(response => {
        this.$store.dispatch('updateUserInfo', payload)
        this.$vs.notify({
            title: 'Updated!',
            text: response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position: 'top-right'
          })
      })
      .catch(error=> {
        this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position: 'top-right'
          })
      })
    },

      countryChanged(country) {
        this.countryCode = country.dialCode
        this.country = country.name
        this.countryIso = country.iso2
      },

   


  }
}
</script>